export enum EmailType {
    ContactUsPage = 0,
    NewOrgAdded = 1,
    NewInstance = 2,
    NewUserAddedOrg = 3,
    NewUserAddedIns = 4,
    DemoUserSignUp = 5,
    NewUserAddNonFedOrg = 6,
}
